import { useFlags as useOriginalFlags } from "@edgetier/feature-flags";
import { FEATURE_FLAGS } from "types-for/feature-flags";

const useFlags = useOriginalFlags<FEATURE_FLAGS>;

export default useFlags;
